// Utils from auth0 MIT Licensed library 'auth0-spa-js'
// https://github.com/auth0/auth0-spa-js/blob/82807e383030d798962cf9eb89fd1354c3f2e174/src/utils.ts

export const createRandomString = () => {
    const charset =
        '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_~.';
    let random = '';
    const randomValues = Array.from(
        getCrypto().getRandomValues(new Uint8Array(43))
    );
    randomValues.forEach(v => (random += charset[v % charset.length]));
    return random;
};

export const getCrypto = () => {
    // ie 11.x uses msCrypto
    return <Crypto>(window.crypto || (<any>window).msCrypto);
};

export const base64Decode = (encodedString: string) => atob(encodedString);
export const base64Encode = (rawString: string) => btoa(rawString);
